import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { fidelizacao_turma } from "../../services/api";

import './detalhamento_bolsa.css';

const Fidelizacao_turma = (props) => {

    const [data2, setData2] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    let data_inicio = props.di;
    let data_fim = props.df;
    let cod_unidade = props.un;

    const fetchData = async () => {
        try {
            const response = await fidelizacao_turma(data_inicio, data_fim, cod_unidade);
            console.log("response", response)
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        console.log("B")
        fetchData();
    }, [data_inicio, data_fim]);

    let TotalPR = 0; // total de possibilidade de renovação
    let TotalRN = 0; // Total de renovados
    let TotalEV = 0; // Total Evasão


    let chartDatTurma = [];

    if (typeof data2 !== 'undefined') {
        chartDatTurma = data2.map((item, index) => {
            const row = [item.turma];
            row.push(parseInt(item.pr));
            row.push(parseInt(item.pr) - parseInt(item.evasao));
            row.push(100 - (parseFloat(item.evasao) * 100) / parseFloat(item.pr))
            row.push((parseFloat(item.evasao) * 100) / parseFloat(item.pr));
            TotalPR = TotalPR + (parseInt(item.pr));
            TotalRN = TotalRN + ((parseInt(item.pr) - parseInt(item.evasao)));
            TotalEV = TotalEV + (parseInt(item.evasao));
            return row;
        });
    };
    let TotalRNP = (100 - (parseFloat(TotalEV) * 100) / parseFloat(TotalPR)); // total de Renovação percentual
    let TotalEVP = ((parseFloat(TotalEV) * 100) / parseFloat(TotalPR)); // total de Renovação percentual

    chartDatTurma.unshift(["TURMA 2026", "P.Rnv", "Rnv", "RENOVAÇÃO", "EVASÃO"]);

    chartDatTurma.push(["TOTAL", TotalPR, TotalRN, TotalRNP, TotalEVP]);

    const options = {
        allowHtml: true,
        page: 'enable',
        pageSize: 20,

    };

    const formatters = [
        {
            type: "NumberFormat",
            column: 3,
            options: {
                suffix: "%",
            },
        },
        {
            type: "BarFormat",
            column: 3,
            options: {
                width: 90,
                base: 0,
                max: 100,
                min: 0,
            },
        },
        {
            type: "NumberFormat",
            column: 4,
            options: {
                suffix: "%",
            },
        },
        {
            type: "ColorFormat",
            column: 4,
            ranges: [
                [0, 25, "white", "green"],
                [25, 40, "white", "orange"],
                [40, 50, "white", "red"],
                [50, 75, "white", "darkred"],
                [75, 100, "white", "black"],
            ],
        },

    ];


    return (
        <div className="Evasão">
            <Chart
                chartType="Table"
                version="current"
                width="100%"
                data={chartDatTurma}
                options={options}
                formatters={formatters}
            />
        </div>
    );
};
export default Fidelizacao_turma;